/* eslint-disable jsx-a11y/iframe-has-title */

import React, { useEffect, useState } from 'react';

import {
  Box,
  Image,
  Button,
  useToast,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Textarea,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Tooltip,
  Text,
} from '@chakra-ui/react';

import {
  FaRegHeart,
  FaRegComment,
  FaRegShareSquare,
  FaPlay,
  FaRegStar,
  FaStar,
  FaUserSlash,
} from 'react-icons/fa';

import { ArrowDownIcon, ExternalLinkIcon, UnlockIcon } from '@chakra-ui/icons';

import Reason from './Reason';

import { reasons } from './reasons';

import {
  useApproveUserChallengeMutation,
  useDeclineUserChallengeMutation,
  useMarkAsFavouriteUserChallengeMutation,
  useUnMarkAsFavouriteUserChallengeMutation,
  useBanUserForFutureChallengesMutation,
} from '../../Redux/features/challenges/challengesApiSlice';

import { useBuyPlanMutation } from '../../Redux/features/plans/plansApiSlice';

import formatNumber from '../../Helpers/formatNumbers';

import DownloadedImageFail from '../../Assets/Images/content-download-fail.png';

import './TikTokCard.css';

import VideoDownloaderButton from '../VideoDownloader';
import BuySparkCodeModal from '../BuySparkCodeModal';

const formatDate = dateString => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // January is 0!
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

const InstagramEmbed = ({ reelUrl }) => {
  useEffect(() => {
    const loadInstagramEmbed = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      } else {
        const script = document.createElement('script');
        script.src = '//www.instagram.com/embed.js';
        script.async = true;
        script.onload = () => {
          window.instgrm.Embeds.process();
        };
        document.body.appendChild(script);
      }
    };

    loadInstagramEmbed();
  }, [reelUrl]);

  return (
    <blockquote
      className="instagram-media"
      data-instgrm-captioned=""
      data-instgrm-permalink={reelUrl}
      data-instgrm-version={14}
      style={{
        background: '#FFF',
        border: 0,
        borderRadius: 3,
        boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
        margin: 1,
        maxWidth: 540,
        minWidth: 326,
        padding: 0,
        width: 'calc(100% - 2px)',
      }}
    >
      <div style={{ padding: 16 }}>
        {' '}
        <a
          href={reelUrl}
          style={{
            background: '#FFFFFF',
            lineHeight: 0,
            padding: '0 0',
            textAlign: 'center',
            textDecoration: 'none',
            width: '100%',
          }}
          target="_blank"
          rel="noreferrer"
        >
          {' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            {' '}
            <div
              style={{
                backgroundColor: '#F4F4F4',
                borderRadius: '50%',
                flexGrow: 0,
                height: 40,
                marginRight: 14,
                width: 40,
              }}
            />{' '}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                justifyContent: 'center',
              }}
            >
              {' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  borderRadius: 4,
                  flexGrow: 0,
                  height: 14,
                  marginBottom: 6,
                  width: 100,
                }}
              />{' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  borderRadius: 4,
                  flexGrow: 0,
                  height: 14,
                  width: 60,
                }}
              />
            </div>
          </div>
          <div style={{ padding: '19% 0' }} />{' '}
          <div
            style={{
              display: 'block',
              height: 50,
              margin: '0 auto 12px',
              width: 50,
            }}
          >
            <svg
              width="50px"
              height="50px"
              viewBox="0 0 60 60"
              version="1.1"
              xmlns="https://www.w3.org/2000/svg"
              xmlnsXlink="https://www.w3.org/1999/xlink"
            >
              <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                <g
                  transform="translate(-511.000000, -20.000000)"
                  fill="#000000"
                >
                  <g>
                    <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631" />
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div style={{ paddingTop: 8 }}>
            {' '}
            <div
              style={{
                color: '#3897f0',
                fontFamily: 'Arial,sans-serif',
                fontSize: 14,
                fontStyle: 'normal',
                fontWeight: 550,
                lineHeight: 18,
              }}
            >
              View this post on Instagram
            </div>
          </div>
          <div style={{ padding: '12.5% 0' }} />{' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginBottom: 14,
              alignItems: 'center',
            }}
          >
            <div>
              {' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  borderRadius: '50%',
                  height: '12.5px',
                  width: '12.5px',
                  transform: 'translateX(0px) translateY(7px)',
                }}
              />{' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  height: '12.5px',
                  transform: 'rotate(-45deg) translateX(3px) translateY(1px)',
                  width: '12.5px',
                  flexGrow: 0,
                  marginRight: 14,
                  marginLeft: 2,
                }}
              />{' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  borderRadius: '50%',
                  height: '12.5px',
                  width: '12.5px',
                  transform: 'translateX(9px) translateY(-18px)',
                }}
              />
            </div>
            <div style={{ marginLeft: 8 }}>
              {' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  borderRadius: '50%',
                  flexGrow: 0,
                  height: 20,
                  width: 20,
                }}
              />{' '}
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: '2px solid transparent',
                  borderLeft: '6px solid #f4f4f4',
                  borderBottom: '2px solid transparent',
                  transform: 'translateX(16px) translateY(-4px) rotate(30deg)',
                }}
              />
            </div>
            <div style={{ marginLeft: 'auto' }}>
              {' '}
              <div
                style={{
                  width: 0,
                  borderTop: '8px solid #F4F4F4',
                  borderRight: '8px solid transparent',
                  transform: 'translateY(16px)',
                }}
              />{' '}
              <div
                style={{
                  backgroundColor: '#F4F4F4',
                  flexGrow: 0,
                  height: 12,
                  width: 16,
                  transform: 'translateY(-4px)',
                }}
              />{' '}
              <div
                style={{
                  width: 0,
                  height: 0,
                  borderTop: '8px solid #F4F4F4',
                  borderLeft: '8px solid transparent',
                  transform: 'translateY(-4px) translateX(8px)',
                }}
              />
            </div>
          </div>{' '}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              justifyContent: 'center',
              marginBottom: 24,
            }}
          >
            {' '}
            <div
              style={{
                backgroundColor: '#F4F4F4',
                borderRadius: 4,
                flexGrow: 0,
                height: 14,
                marginBottom: 6,
                width: 224,
              }}
            />{' '}
            <div
              style={{
                backgroundColor: '#F4F4F4',
                borderRadius: 4,
                flexGrow: 0,
                height: 14,
                width: 144,
              }}
            />
          </div>
        </a>
        <p
          style={{
            color: '#c9c8cd',
            fontFamily: 'Arial,sans-serif',
            fontSize: 14,
            lineHeight: 17,
            marginBottom: 0,
            marginTop: 8,
            overflow: 'hidden',
            padding: '8px 0 7px',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          <a
            href={reelUrl}
            style={{
              color: '#c9c8cd',
              fontFamily: 'Arial,sans-serif',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeight: 'normal',
              lineHeight: 17,
              textDecoration: 'none',
            }}
            target="_blank"
            rel="noreferrer"
          >
            A post shared by CRUWI (@cruwi_)
          </a>
        </p>
      </div>
    </blockquote>
  );
};

export default function TikTokCard({
  userChallenge,
  showActionButtons,
  isPending,
  isApproved,
  isInstagramChallenge,
  isStory,
  isPhotoMode,
}) {
  const { video, challengeId, isFavourite, userId } = userChallenge;

  // Notifications
  const toast = useToast();
  const showToast = (message, type, duration) => {
    toast({
      title: `${message}`,
      status: type,
      isClosable: true,
      duration,
    });
  };

  const [selectedReasons, setSelectedReasons] = useState([]);
  const [customComment, setCustomComment] = useState('');

  const handleCustomCommentChange = e => {
    setCustomComment(e.target.value);
  };

  const handleCheck = (text, isChecked) => {
    if (isChecked) {
      setSelectedReasons(prev => [...prev, text]);
    } else {
      setSelectedReasons(prev => prev.filter(item => item !== text));
    }
  };

  // Approve rating
  const [sliderValue, setSliderValue] = useState(0);

  // Deny rating
  const [denySliderValue, setDenySliderValue] = useState(0);

  const [showTooltip, setShowTooltip] = useState(false);

  const [buyPlan] = useBuyPlanMutation();

  const [approve, { isLoading: isLoadingApprove }] =
    useApproveUserChallengeMutation();

  const [decline, { isLoading: isLoadingDecline }] =
    useDeclineUserChallengeMutation();

  const [markAsFavourite, { isLoading: isLoadingMarkAsFavourite }] =
    useMarkAsFavouriteUserChallengeMutation();

  const [unMarkAsFavourite, { isLoading: isLoadingUnMarkAsFavourite }] =
    useUnMarkAsFavouriteUserChallengeMutation();

  const [
    banUserForFutureChallenges,
    { isLoading: isLoadingBanUserForFutureChallenges },
  ] = useBanUserForFutureChallengesMutation();

  // Reason Modal
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Rate Video Modal
  const {
    isOpen: isOpenRateVideoModal,
    onOpen: onOpenRateVideoModal,
    onClose: onCloseRateVideoModal,
  } = useDisclosure();

  // Spark Code Modal
  const {
    isOpen: isOpenSparkCodeModal,
    onOpen: onOpenSparkCodeModal,
    onClose: onCloseSparkCodeModal,
  } = useDisclosure();

  // Download Video Modal
  const {
    isOpen: isOpenDownloadVideoModal,
    onOpen: onOpenDownloadVideoModal,
    onClose: onCloseDownloadVideoModal,
  } = useDisclosure();

  // Ban User Modal
  const {
    isOpen: isOpenBanUserModal,
    onOpen: onOpenBanUserModal,
    onClose: onCloseBanUserModal,
  } = useDisclosure();

  // Main actions
  const approveChallenge = async () => {
    const feedback = {
      feedback: {
        rating: sliderValue + 5,
      },
    };

    try {
      await approve({
        userId: userId,
        challengeId: challengeId,
        feedback,
      }).unwrap();
    } catch (error) {
      showToast(
        'Aprobar este reto puede suponer superar el presupuesto establecido',
        'error',
        3000
      );
      console.log(error);
    }
  };

  const declineChallenge = async () => {
    const description = customComment
      ? [...selectedReasons, customComment]
      : selectedReasons;

    if (selectedReasons.length === 0) {
      showToast('Debes seleccionar al menos un motivo', 'error', 3000);
      return;
    }

    const feedback = {
      feedback: {
        rating: denySliderValue,
        description,
      },
    };

    try {
      await decline({
        userId: userId,
        challengeId: challengeId,
        feedback,
      }).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const markFavourite = async () => {
    try {
      await markAsFavourite({
        userId: userId,
        challengeId: challengeId,
      }).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const unMarkFavourite = async () => {
    try {
      await unMarkAsFavourite({
        userId: userId,
        challengeId: challengeId,
      }).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const requestVideoDownload = async () => {
    const paymentObject = {
      products: {
        prod_QTuAiGMAZZwcNG: 1,
      },
      type: 'video-download',
      metadata: {
        externalId: video.externalId,
      },
    };

    try {
      const buyPlanResult = await buyPlan(paymentObject).unwrap();
      window.location.replace(buyPlanResult);
    } catch (error) {
      console.log(error);
    }
  };

  const banUser = async () => {
    try {
      await banUserForFutureChallenges({ userId: userId }).unwrap();
      onCloseBanUserModal();
      showToast(
        'Usuario baneado correctamente para futuros retos',
        'success',
        3000
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleGoToTikTokVideo = url => {
    window.open(url, '_blank');
  };

  return (
    <Flex
      width={isPending ? '550px' : '600px'}
      border="1px solid #e2e8f0"
      borderRadius="lg"
      mb={5}
    >
      {/* TikTok y acciones */}
      <Box>
        {/* Renderizamos el TikTok o la imagen si es photoMode */}
        <Box p="0 20px 0px 20px">
          {isPhotoMode ? (
            <Box
              mb={2}
              height="100%"
              p="20px 0 0 0"
              borderRadius="8px"
              maxW="323px"
            >
              <Image
                borderRadius="8px"
                width="100%"
                src={video?.downloadedImageUrl || DownloadedImageFail}
              />
            </Box>
          ) : isInstagramChallenge && isStory ? (
            <Box
              mt={4}
              height="640px"
              width="360px"
              backgroundPosition="center"
              backgroundSize="cover"
              backgroundRepeat="no-repeat"
              backgroundImage={video?.coverImageUrl}
              borderRadius={4}
            />
          ) : isInstagramChallenge && !isStory ? (
            <InstagramEmbed reelUrl={video?.shareUrl} />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: video?.embedHtml }}></div>
          )}
        </Box>

        <Box p="0 0 20px 20px">
          <Text fontSize="12px">
            Fecha de publicación: <i>{formatDate(video.createTime)}</i>
          </Text>
        </Box>

        {showActionButtons && (
          <Box p="0 0 20px 20px">
            <Flex justify="space-between">
              <Button
                isLoading={isLoadingApprove}
                colorScheme="green"
                onClick={onOpenRateVideoModal}
              >
                Aprobar
              </Button>
              <Button
                isLoading={isLoadingDecline}
                colorScheme="red"
                onClick={onOpen}
              >
                Denegar
              </Button>
            </Flex>
            <Text fontWeight="bold" mt={5} lineHeight={1.2} fontSize="12px">
              Aprueba el vídeo para ver todas las estadísticas y solicitar el
              Spark Code
            </Text>
          </Box>
        )}

        <Box p="0 0 20px 20px">
          <Flex justify="space-between">
            {isApproved &&
              (video.downloadUrl ? (
                <VideoDownloaderButton
                  isSmall={false}
                  videoUrl={video.downloadUrl}
                  filename={video._id}
                />
              ) : (
                <Button
                  ml={2}
                  leftIcon={<ArrowDownIcon />}
                  size="md"
                  onClick={() => onOpenDownloadVideoModal()}
                >
                  Solicitar derechos
                </Button>
              ))}
            {isApproved && !isInstagramChallenge && (
              <Button
                ml={2}
                leftIcon={<UnlockIcon />}
                size="md"
                onClick={() => onOpenSparkCodeModal()}
              >
                Solicitar Spark Code
              </Button>
            )}
          </Flex>
        </Box>

        {/* Deny Reasons Modal */}
        <Modal onClose={onClose} isOpen={isOpen} isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Valora y selecciona el motivo</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box
                p={5}
                border="1px solid #e2e8f0"
                mb="20px"
                borderRadius="8px"
              >
                <Text fontSize="16px" mb={5}>
                  Tu valoración: <strong>{denySliderValue}</strong>
                </Text>
                <Slider
                  id="slider"
                  defaultValue={0}
                  min={0}
                  max={4}
                  step={1}
                  colorScheme="teal"
                  onChange={v => setDenySliderValue(v)}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  <SliderMark value={0} mt="1" ml="-2.5" fontSize="sm">
                    0
                  </SliderMark>

                  <SliderMark value={1} mt="1" ml="-2.5" fontSize="sm">
                    1
                  </SliderMark>

                  <SliderMark value={2} mt="1" ml="-2.5" fontSize="sm">
                    2
                  </SliderMark>

                  <SliderMark value={3} mt="1" ml="-2.5" fontSize="sm">
                    3
                  </SliderMark>

                  <SliderMark value={4} mt="1" ml="-2.5" fontSize="sm">
                    4
                  </SliderMark>

                  <SliderTrack>
                    <SliderFilledTrack />
                  </SliderTrack>

                  <Tooltip
                    hasArrow
                    bg="gray"
                    color="white"
                    placement="top"
                    isOpen={showTooltip}
                    label={`${denySliderValue}`}
                  >
                    <SliderThumb />
                  </Tooltip>
                </Slider>
              </Box>
              <Box>
                <Text mb={3} fontSize="16px" fontWeight="bold">
                  Selecciona todas las que correspondan y/o añade un comentario
                  de feedback
                </Text>
                <ul className="ks-cboxtags">
                  {reasons.map(reason => (
                    <Reason
                      key={reason.id}
                      id={reason.id}
                      text={reason.text}
                      onCheck={handleCheck}
                    />
                  ))}
                </ul>
                <Box mt={3} mb={3} />
                <Textarea
                  onChange={handleCustomCommentChange}
                  placeholder="Add custom feedback"
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button onClick={onClose} mr={3}>
                Close
              </Button>
              <Button
                isLoading={isLoadingDecline}
                colorScheme="red"
                onClick={() => declineChallenge()}
              >
                Enviar feedback
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Vote Quality Slider Modal */}
        <Modal
          onClose={onCloseRateVideoModal}
          isOpen={isOpenRateVideoModal}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Valora el vídeo</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box p={5} border="1px solid #e2e8f0" borderRadius="8px">
                <Text fontSize="16px" mb={5}>
                  Tu valoración: <strong>{sliderValue + 5}</strong>
                </Text>
                <Slider
                  id="slider"
                  defaultValue={0}
                  min={0}
                  max={5}
                  step={1}
                  colorScheme="teal"
                  onChange={v => setSliderValue(v)}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                >
                  <SliderMark value={0} mt="1" ml="-2.5" fontSize="sm">
                    5
                  </SliderMark>

                  <SliderMark value={1} mt="1" ml="-2.5" fontSize="sm">
                    6
                  </SliderMark>

                  <SliderMark value={2} mt="1" ml="-2.5" fontSize="sm">
                    7
                  </SliderMark>

                  <SliderMark value={3} mt="1" ml="-2.5" fontSize="sm">
                    8
                  </SliderMark>

                  <SliderMark value={4} mt="1" ml="-2.5" fontSize="sm">
                    9
                  </SliderMark>

                  <SliderMark value={5} mt="1" ml="-2.5" fontSize="sm">
                    10
                  </SliderMark>

                  <SliderTrack>
                    <SliderFilledTrack />
                  </SliderTrack>

                  <Tooltip
                    hasArrow
                    bg="teal.500"
                    color="white"
                    placement="top"
                    isOpen={showTooltip}
                    label={`${sliderValue + 5}`}
                  >
                    <SliderThumb />
                  </Tooltip>
                </Slider>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button onClick={onCloseRateVideoModal} mr={3}>
                Cerrar
              </Button>
              <Button
                isLoading={isLoadingApprove}
                colorScheme="green"
                onClick={() => approveChallenge()}
              >
                Aprobar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Download Video Modal */}
        <Modal
          onClose={onCloseDownloadVideoModal}
          isOpen={isOpenDownloadVideoModal}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Solicitar derechos</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text mb={2}>La descarga del video tiene un coste de 30€.</Text>
                <Text>
                  Una vez realizado el pago, podrás descargar el vídeo del
                  creador y utilizarlo donde prefieras.
                </Text>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onCloseDownloadVideoModal}>
                Cancelar
              </Button>
              <Button
                bg="black"
                color="white"
                _hover={{ bg: '#000', opacity: 0.75 }}
                onClick={requestVideoDownload}
              >
                Pagar y descargar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        <BuySparkCodeModal
          onClose={onCloseSparkCodeModal}
          isOpen={isOpenSparkCodeModal}
          videoId={video.externalId}
          challengeId={challengeId}
        />

        {/* Ban user Modal */}
        <Modal
          onClose={onCloseBanUserModal}
          isOpen={isOpenBanUserModal}
          isCentered
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>¿Quieres banear a este creador?</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text mb={2}>
                  Esta acción hará que este creador no pueda participar en
                  ninguno de tus futuros retos.
                </Text>
              </Box>
            </ModalBody>
            <ModalFooter>
              <Button mr={3} onClick={onCloseSparkCodeModal}>
                Cancelar
              </Button>
              <Button
                bg="black"
                color="white"
                _hover={{ bg: '#000', opacity: 0.75 }}
                onClick={() => banUser()}
                isLoading={isLoadingBanUserForFutureChallenges}
              >
                Sí, banear
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>

      {/* Ampliamos más info el TikTok card */}
      <Box p="20px">
        <Box>
          <Text mb={1} fontSize="14px" fontWeight="bold">
            Otras acciones
          </Text>
          <Button
            leftIcon={<ExternalLinkIcon />}
            size="xs"
            width="100%"
            mb={1}
            onClick={() => handleGoToTikTokVideo(video?.shareUrl)}
          >
            {isInstagramChallenge && !isStory
              ? 'Ver Reel'
              : isStory
              ? 'Ver historia'
              : 'Abrir en TikTok'}
          </Button>
          {!isPending && (
            <>
              <Button
                leftIcon={isFavourite ? <FaStar /> : <FaRegStar />}
                width="100%"
                size="xs"
                mb={1}
                isLoading={
                  isLoadingMarkAsFavourite || isLoadingUnMarkAsFavourite
                }
                onClick={() =>
                  isFavourite ? unMarkFavourite() : markFavourite()
                }
              >
                {isFavourite ? 'Ya es favorito' : 'Marcar favorito'}
              </Button>
              <Button
                onClick={onOpenBanUserModal}
                leftIcon={<FaUserSlash />}
                width="100%"
                size="xs"
              >
                Banear creador
              </Button>
            </>
          )}
          <Box height="20px" />
          <Text mb={2} fontSize="14px" fontWeight="bold">
            Estadísticas
          </Text>
          <Flex flexDir="column">
            <Box mb={5}>
              <FaRegHeart size="25px" />
              <Text
                filter={isPending ? 'blur(3px)' : 'none'}
                fontSize="16px"
                mt={1}
              >
                {isPending ? 'hidden' : formatNumber(video.likeTotalCount)}
              </Text>
            </Box>
            <Box mb={5}>
              <FaRegComment size="25px" />
              <Text
                filter={isPending ? 'blur(3px)' : 'none'}
                fontSize="16px"
                mt={1}
              >
                {isPending ? 'hidden' : formatNumber(video.commentTotalCount)}
              </Text>
            </Box>
            <Box mb={5}>
              <FaRegShareSquare size="25px" />
              <Text
                filter={isPending ? 'blur(3px)' : 'none'}
                fontSize="16px"
                mt={1}
              >
                {isPending ? 'hidden' : formatNumber(video.shareTotalCount)}
              </Text>
            </Box>
            <Box>
              <FaPlay size="25px" />
              <Text
                filter={isPending ? 'blur(3px)' : 'none'}
                fontSize="16px"
                mt={1}
              >
                {isPending ? 'hidden' : formatNumber(video.viewTotalCount)}
              </Text>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
}
